import moment from 'moment/moment';
const axios = require('axios');

(() => {
  const calendarTable = '.camping-calendar-table';
  const calendarTableText = '.camping-calendar-text';
  const prevWeekButton = '.move-to-prev-camping-week';
  const nextWeekButton = '.move-to-next-camping-week';
  const campingCalendarInfo = '.camping-calendar-info';
  const adultNumPulldown = '.camping-adult-num';
  const kidsNumPulldown = '.camping-kids-num';
  const babyNumPulldown = '.camping-baby-num';
  const numberOfSections = '.camping-section-js';
  const siteA = '.site-a';
  const siteB = '.site-b';
  const siteCNomal = '.site-c-nomal';
  const lodgeA = '.lodge-a';
  const lodgeB = '.lodge-b';
  const dateRangePicker = 'input[class="camping-daterange"]';
  const campingShowDisabledButton = '.camping-show-disabled-button';
  const campingShowActiveButton = '.camping-show-active-button';
  const campingDisabledButton = '.camping-disabled-button';
  const reserveStartDate = '#camping-reserve-start-date';
  const reserveEndDate = '#camping-reserve-end-date';
  const reserveCheckoutDate = '#camping-checkout-date';
  const unavailableAnyAreasInfo = '.unavailable_any_camping_areas_info';

  var firstDateValue = {};
  var lastDateValue = {};
  var totalDiffDateKey = {};
  var firstDateWeakMap = new WeakMap;
  var lastDateWeakMap = new WeakMap;
  var diffReserveDateLength = new WeakMap;

  let MINDATE;
  if (moment().hour() >= 12) {
    MINDATE = moment().add(1, 'days');
  } else {
    MINDATE = moment();
  }

  const LODGE_START_DATE = moment('20210401');

  const init = () => {
    if (location.href.indexOf('customer/camping/camping_reservation') < 1 ) {
      return
    }
    if ($(calendarTable).length < 1) {
      return
    }

    $(calendarTable).hide();
    $(calendarTableText).hide();
    $(prevWeekButton).hide();
    $(nextWeekButton).hide();
    $(campingCalendarInfo).hide();
    $(campingShowDisabledButton).show();
    $(campingShowActiveButton).hide();
    $(campingDisabledButton).prop('disabled', true);
    $('.after_info_open_camping_calendar').removeClass('active');
    $(unavailableAnyAreasInfo).hide();

    $('body')
      .on('change', adultNumPulldown, showInitWeekReservationStatus)
      .on('change', kidsNumPulldown, showInitWeekReservationStatus)
      .on('change', babyNumPulldown, showInitWeekReservationStatus)
      .on('change', numberOfSections, showInitWeekReservationStatus)
      .on('change', adultNumPulldown, limitNumberOfSections)
      .on('change', kidsNumPulldown, limitNumberOfSections)
      .on('change', babyNumPulldown, limitNumberOfSections)
      .on('click', nextWeekButton, showNextWeekReservationStatus)
      .on('click', prevWeekButton, showPrevWeekReservationStatus)
      .on('click', siteA, setSiteAValue)
      .on('click', siteB, setSiteBValue)
      .on('click', siteCNomal, setSiteCNomalValue)
      .on('click', lodgeA, setLodgeAValue)
      .on('click', lodgeB, setLodgeBValue);

    let reserveStartDateVal = $(reserveStartDate).val();
    let reserveCheckoutDateVal = $(reserveCheckoutDate).val();
    const currentDate = MINDATE;

    if (!reserveStartDateVal) {
      reserveStartDateVal = moment(currentDate).format('YYYY/MM/DD')
      reserveCheckoutDateVal = moment(currentDate).add(1, 'days').format('YYYY/MM/DD')
    }

    $(dateRangePicker).daterangepicker({
      minDate: MINDATE.format('YYYYMMDD'),
      parentEl: '.reservation-camping-date',
      startDate: `${reserveStartDateVal}`,
      endDate:  `${reserveCheckoutDateVal}`,
      autoApply: true,
      singleDateRangePicker: true,
      locale: {
        format: 'YYYY年MM月DD日（dd）',
        applyLabel: '選択する',
        cancelLabel: '閉じる'
      }
    });

    showInitWeekReservationStatus();

    $('body').on('change', dateRangePicker, dateRangeChange)
  }

  const dateRangeChange = e => {
    if (e) {
      e.preventDefault();
    }
    $('#camping-area-id').val('')
    $(campingShowDisabledButton).show();
    $(campingShowActiveButton).hide();
    $(campingDisabledButton).prop('disabled', true);
    showInitWeekReservationStatus();
  }

  const showInitWeekReservationStatus = e => {
    if (e) {
      e.preventDefault();
    }
    if ($(adultNumPulldown).val() < 1) {
      hideReservationStatusCalendar();
      $(unavailableAnyAreasInfo).hide();
      return
    }

    let dateRange = $(dateRangePicker).val();
    dateRange = dateRange.replace(/\(|\)|（|）|日|月|火|水|木|金|土|年|月|日|泊/g, '');

    const dateRangeArray = dateRange.split('-');
    const startReserveDate = dateRangeArray[0].trim();
    const nights = dateRangeArray[1];
    const endReserveDate = moment(startReserveDate).add(parseInt(nights), 'd')
    const reserveStartDateSelectObj = moment(startReserveDate)
    const reserveEndDateSelectObj = moment(endReserveDate)
    registerDiffReserveDateLength(reserveEndDateSelectObj.toDate(), reserveStartDateSelectObj.toDate());

    const currentDateObj = MINDATE;
    if (reserveStartDateSelectObj.isAfter(currentDateObj.format('YYYY-MM-DD'))) {
      var firstDateString = reserveStartDateSelectObj.format('YYYY-MM-DD')
      $(prevWeekButton).prop('disabled', false).removeClass('disabled');
    } else {
      var firstDateString = currentDateObj.add(0, 'd').format('YYYY-MM-DD')
      $(prevWeekButton).prop('disabled', true).addClass('disabled');
    }

    $(calendarTable).show();
    $(calendarTableText).show();
    $(prevWeekButton).show();
    if (reserveStartDateSelectObj.isBefore(currentDateObj.format('YYYY-MM-DD'))) {
      $(prevWeekButton).prop('disabled', true).addClass('disabled');
    }
    $(nextWeekButton).show();
    $(campingCalendarInfo).show();
    $('.before_info_open_camping_calendar').hide();
    $('.after_info_open_camping_calendar').addClass('active');
    if ($('#camping-area-id').val()) {
      $(campingShowDisabledButton).hide();
      $(campingShowActiveButton).show();
      $(campingDisabledButton).prop('disabled', false);
    } else {
      $(campingShowDisabledButton).show();
      $(campingShowActiveButton).hide();
      $(campingDisabledButton).prop('disabled', true);
    }

    removePrependedCalendarInfo();
    fetchReservationStatus(firstDateString);
    checkValidPeopleAndSections();
  }

  const showNextWeekReservationStatus = e => {
    e.preventDefault();
    $(prevWeekButton).prop('disabled', false).removeClass('disabled');
    const lastDateString = lastDateWeakMap.get(lastDateValue);
    var lastDate = new Date(lastDateString);
    lastDate.setDate(lastDate.getDate() + 1);
    const nextDateString = getStringFromDate(lastDate);
    removePrependedCalendarInfo();
    fetchReservationStatus(nextDateString);
  }

  const showPrevWeekReservationStatus = e => {
    e.preventDefault();
    const currentDate = MINDATE;
    const firstDateString = firstDateWeakMap.get(firstDateValue);
    var firstDate = moment(firstDateString);
    firstDate.subtract(5, 'd');
    if (moment(firstDate).format('YYYY/MM/DD') == moment(currentDate).format('YYYY/MM/DD')) {
      $(prevWeekButton).prop('disabled', true).addClass('disabled');
    } else {
      $(prevWeekButton).prop('disabled', false).removeClass('disabled');
    }
    const prevWeekfirstDateString = firstDate.format('YYYY-MM-DD');
    removePrependedCalendarInfo();
    fetchReservationStatus(prevWeekfirstDateString);
  }

  const fetchReservationStatus = date => {
    let dateRange = $(dateRangePicker).val();
    const dateRangeArray = dateRange.split('-');
    const startReserveDate = moment(date).format('YYYY-MM-DD');
    let nights = dateRangeArray[1];
    nights = nights.replace(/泊/g, '').trim();
    axios.get(process.env.JS_BASE_URL + 'api/v1/camping_calendars', {
      params: {
        date: startReserveDate,
        nights: nights
      }
    })
    .then(response => {
      if (response.data.every(v => v.length === 0)) {
        hideReservationStatusCalendar();
        $(unavailableAnyAreasInfo).show();
      } else {
        removePrependedCalendarInfo();
        showCalendarDate(response.data);
        showCalendarArea();

        const siteAReservations = response.data[0];
        const siteBReservations = response.data[1];
        const siteCNomalReservations = response.data[2];
        const lodgeAReservations = response.data[3];
        const lodgeBReservations = response.data[4];
        const selectedArea = $('#camping-area-id').val();

        if (siteAReservations.length > 0) {
          siteAReservations.forEach(reservation => {
            const futureDate = new Date();
            futureDate.setMonth(futureDate.getMonth() + 6);
            const date = new Date(reservation.date);
            const subscriptionTotalPeople = checkSubscriptionTotalNum(reservation);
            const charge = prepareReservationCharge(reservation, subscriptionTotalPeople);

            let selectedDate = $('#camping-reserve-start-date').val();
            if (selectedArea != 4) {
              selectedDate = ''
            }
            let addTdStyle = '';
            let addAStyle = '';
            let addSelectClass = '';
            if (reservation.date == selectedDate) {
              addTdStyle = 'background-color: #527342;';
              addAStyle = 'background-color: #fff;';
              addSelectClass = 'select-date reservation-check-mark';
            }

            if (futureDate.getTime() > date.getTime()) {
              if (reservation.non_business_date === true) {
                $('#calendar-camping-a-site-reservation-num').append(`<td class='unavailable-reservation'><div data-date=${reservation.date} data-site='site-a'>-</div></td>`);
              } else {
                if (reservation.reservation_rate >= 100) {
                  $('#calendar-camping-a-site-reservation-num').append(`<td class='unavailable-reservation times-mark'><span data-date=${reservation.date} data-site='site-a'></span></td>`);
                } else if (reservation.reservation_rate >= 80) {
                  if (subscriptionTotalPeople === 1) {
                    $('#calendar-camping-a-site-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-a' data-date=${reservation.date} data-site='site-a' href='' style='${addAStyle}'><span class='click-underline triangle-mark'></span></a></td>`);
                  } else if (subscriptionTotalPeople > 1) {
                    $('#calendar-camping-a-site-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-a' data-date=${reservation.date} data-site='site-a' href='' style='${addAStyle}'>${reservation.charge.toLocaleString()}<span class='click-underline triangle-mark'></span></a></td>`);
                  } else {
                    $('#calendar-camping-a-site-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-a' data-date=${reservation.date} data-site='site-a' href='' style='${addAStyle}'>${reservation.charge.toLocaleString()}<span class='click-underline triangle-mark'></span></a></td>`);
                  }
                } else {
                  if (subscriptionTotalPeople === 1) {
                    $('#calendar-camping-a-site-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-a' data-date=${reservation.date} data-site='site-a' href='' style='${addAStyle}'><span class='click-underline circle-mark'></span></a></td>`);
                  } else if (subscriptionTotalPeople > 1) {
                    $('#calendar-camping-a-site-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-a' data-date=${reservation.date} data-site='site-a' href='' style='${addAStyle}'>${charge.toLocaleString()}<span class='click-underline circle-mark'></span></a></td>`);
                  } else {
                    $('#calendar-camping-a-site-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-a' data-date=${reservation.date} data-site='site-a' href='' style='${addAStyle}'>${charge.toLocaleString()}<span class='click-underline circle-mark'></span></a></td>`);
                  }
                }
              }
            } else {
              $('#calendar-camping-a-site-reservation-num').append(`<td class='unavailable-reservation'><span data-date=${reservation.date} data-site='site-a'>-</span></td>`);
            }
          })
          $('#calendar-camping-a-site-reservation-num').prepend(`<th><a href='' class='text-link site-a-modal-button' data-target='#campingAreaModal' data-toggle='modal'>${siteAReservations[0].site_name}</a></th>`);
        }

        if (siteBReservations.length > 0) {
          siteBReservations.forEach(reservation => {
            const futureDate = new Date();
            futureDate.setMonth(futureDate.getMonth() + 6);
            const date = new Date(reservation.date);
            const subscriptionTotalPeople = checkSubscriptionTotalNum(reservation);
            const charge = prepareReservationCharge(reservation, subscriptionTotalPeople);

            let selectedDate = $('#camping-reserve-start-date').val();
            if (selectedArea != 3) {
              selectedDate = ''
            }
            let addTdStyle = '';
            let addAStyle = '';
            let addSelectClass = '';
            if (reservation.date == selectedDate) {
              addTdStyle = 'background-color: #527342;';
              addAStyle = 'background-color: #fff;';
              addSelectClass = 'select-date reservation-check-mark';
            }

            if (futureDate.getTime() > date.getTime()) {
              if (reservation.non_business_date === true) {
                $('#calendar-camping-b-site-reservation-num').append(`<td class='unavailable-reservation'><div data-date=${reservation.date} data-site='site-b'>-</div></td>`);
              } else {
                if (reservation.reservation_rate >= 100) {
                  $('#calendar-camping-b-site-reservation-num').append(`<td class='unavailable-reservation times-mark'><span data-date=${reservation.date} data-site='site-b'></span></td>`);
                } else if (reservation.reservation_rate >= 80) {
                  if (subscriptionTotalPeople === 1) {
                    $('#calendar-camping-b-site-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-b' data-date=${reservation.date} data-site='site-b' href='' style='${addAStyle}'><span class='click-underline triangle-mark'></span></a></td>`);
                  } else if (subscriptionTotalPeople > 1) {
                    $('#calendar-camping-b-site-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-b' data-date=${reservation.date} data-site='site-b' href='' style='${addAStyle}'>${charge.toLocaleString()}<span class='click-underline triangle-mark'></span></a></td>`);
                  } else {
                    $('#calendar-camping-b-site-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-b' data-date=${reservation.date} data-site='site-b' href='' style='${addAStyle}'>${charge.toLocaleString()}<span class='click-underline triangle-mark'></span></a></td>`);
                  }
                } else {
                  if (subscriptionTotalPeople === 1) {
                    $('#calendar-camping-b-site-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-b' data-date=${reservation.date} data-site='site-b' href='' style='${addAStyle}'><span class='click-underline circle-mark'></span></a></td>`);
                  } else if (subscriptionTotalPeople > 1) {
                    $('#calendar-camping-b-site-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-b' data-date=${reservation.date} data-site='site-b' href='' style='${addAStyle}'>${charge.toLocaleString()}<span class='click-underline circle-mark'></span></a></td>`);
                  } else {
                    $('#calendar-camping-b-site-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-b' data-date=${reservation.date} data-site='site-b' href='' style='${addAStyle}'>${charge.toLocaleString()}<span class='click-underline circle-mark'></span></a></td>`);
                  }
                }
              }
            } else {
              $('#calendar-camping-b-site-reservation-num').append(`<td class='unavailable-reservation'><span data-date=${reservation.date} data-site='site-b'></span></td>`);
            }
          })
          $('#calendar-camping-b-site-reservation-num').prepend(`<th><a href='' class='text-link site-b-modal-button' data-target='#campingAreaModal' data-toggle='modal'>${siteBReservations[0].site_name}</a></th>`);
        }

        if (siteCNomalReservations.length > 0) {
          siteCNomalReservations.forEach(reservation => {
            const futureDate = new Date();
            futureDate.setMonth(futureDate.getMonth() + 6);
            const date = new Date(reservation.date);
            const subscriptionTotalPeople = checkSubscriptionTotalNum(reservation);
            const charge = prepareReservationCharge(reservation, subscriptionTotalPeople);

            let selectedDate = $('#camping-reserve-start-date').val();
            if (selectedArea != 1) {
              selectedDate = ''
            }
            let addTdStyle = '';
            let addAStyle = '';
            let addSelectClass = '';
            if (reservation.date == selectedDate) {
              addTdStyle = 'background-color: #527342;';
              addAStyle = 'background-color: #fff;';
              addSelectClass = 'select-date reservation-check-mark';
            }

            if (futureDate.getTime() > date.getTime()) {
              if (reservation.non_business_date === true) {
                $('#calendar-camping-site-c-nomal-reservation-num').append(`<td class='unavailable-reservation'><div data-date=${reservation.date} data-site='site-c-normal'>-</div></td>`);
              } else {
                if (reservation.reservation_rate >= 100) {
                  $('#calendar-camping-site-c-nomal-reservation-num').append(`<td class='unavailable-reservation times-mark'><span data-date=${reservation.date} data-site='site-c-normal'></span></td>`);
                } else if (reservation.reservation_rate >= 80) {
                  if (subscriptionTotalPeople === 1) {
                    $('#calendar-camping-site-c-nomal-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-c-nomal' data-date=${reservation.date} data-site='site-c-normal' href='' style='${addAStyle}'><span class='click-underline triangle-mark'></span></a></td>`);
                  } else if (subscriptionTotalPeople > 1) {
                    $('#calendar-camping-site-c-nomal-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-c-nomal' data-date=${reservation.date} data-site='site-c-normal' href='' style='${addAStyle}'>${charge.toLocaleString()}<span class='click-underline triangle-mark'></span></a></td>`);
                  } else {
                    $('#calendar-camping-site-c-nomal-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-c-nomal' data-date=${reservation.date} data-site='site-c-normal' href='' style='${addAStyle}'>${charge.toLocaleString()}<span class='click-underline triangle-mark'></span></a></td>`);
                  }
                } else {
                  if (subscriptionTotalPeople === 1) {
                    $('#calendar-camping-site-c-nomal-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-c-nomal' data-date=${reservation.date} data-site='site-c-normal' href='' style='${addAStyle}'><span class='click-underline circle-mark'></span></a></td>`);
                  } else if (subscriptionTotalPeople > 1) {
                    $('#calendar-camping-site-c-nomal-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-c-nomal' data-date=${reservation.date} data-site='site-c-normal' href='' style='${addAStyle}'>${charge.toLocaleString()}<span class='click-underline circle-mark'></span></a></td>`);
                  } else {
                    $('#calendar-camping-site-c-nomal-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='site-c-nomal' data-date=${reservation.date} data-site='site-c-normal' href='' style='${addAStyle}'>${charge.toLocaleString()}<span class='click-underline circle-mark'></span></a></td>`);
                  }
                }
              }
            } else {
              $('#calendar-camping-site-c-nomal-reservation-num').append(`<td class='unavailable-reservation'><span data-date=${reservation.date} data-site='site-c-normal'>-</span></td>`);
            }
          })
          $('#calendar-camping-site-c-nomal-reservation-num').prepend(`<th><a href='' class='text-link site-c-modal-button' data-target='#campingAreaModal' data-toggle='modal'>${siteCNomalReservations[0].site_name}</a></th>`);
        }

        if (lodgeAReservations.length > 0) {
          lodgeAReservations.forEach(reservation => {
            const futureDate = new Date();
            futureDate.setMonth(futureDate.getMonth() + 6);
            const date = new Date(reservation.date);
            const charge = prepareLodgeCharge(reservation, $(adultNumPulldown).val());

            let selectedDate = $('#camping-reserve-start-date').val();
            if (selectedArea != 5) {
              selectedDate = ''
            }
            let addTdStyle = '';
            let addAStyle = '';
            let addSelectClass = '';
            if (reservation.date == selectedDate) {
              addTdStyle = 'background-color: #527342;';
              addAStyle = 'background-color: #fff;';
              addSelectClass = 'select-date reservation-check-mark';
            }

            if (LODGE_START_DATE.isAfter(date)) {
              $('#lodge-a-reservation-num').append(`<td class='unavailable-reservation'><span data-date=${reservation.date} data-site='lodge-a'>-</span></td>`);
            } else if (futureDate.getTime() > date.getTime()) {
              if (reservation.non_business_date === true || $(numberOfSections).val() > 2 || lodgeALimitation())  {
                $('#lodge-a-reservation-num').append(`<td class='unavailable-reservation'><div data-date=${reservation.date} data-site='lodge-a'>-</div></td>`);
              } else {
                if (reservation.reservation_rate >= 100) {
                  $('#lodge-a-reservation-num').append(`<td class='unavailable-reservation times-mark'><span data-date=${reservation.date} data-site='lodge-a'></span></td>`);
                } else if (reservation.reservation_rate >= 80) {
                  $('#lodge-a-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='lodge-a' data-date=${reservation.date} data-site='lodge-a' href='' style='${addAStyle}'>${charge.toLocaleString()}<span class='click-underline triangle-mark'></span></a></td>`);
                } else {
                  $('#lodge-a-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='lodge-a' data-date=${reservation.date} data-site='lodge-a' href='' style='${addAStyle}'>${charge.toLocaleString()}<span class='click-underline circle-mark'></span></a></td>`);
                }
              }
            } else {
              $('#lodge-a-reservation-num').append(`<td class='unavailable-reservation'><span data-date=${reservation.date} data-site='lodge-a'></span></td>`);
            }
          })
          $('#lodge-a-reservation-num').prepend(`<th><a href='' class='text-link lodge-a-modal-button' data-target='#campingAreaModal' data-toggle='modal'>${lodgeAReservations[0].site_name}</a></th>`);
        }

        if (lodgeBReservations !== undefined && lodgeBReservations.length > 0) {
          lodgeBReservations.forEach(reservation => {
            const futureDate = new Date();
            futureDate.setMonth(futureDate.getMonth() + 6);
            const date = new Date(reservation.date);
            const charge = prepareLodgeCharge(reservation, $(adultNumPulldown).val());

            let selectedDate = $('#camping-reserve-start-date').val();
            if (selectedArea != 6) {
              selectedDate = ''
            }
            let addTdStyle = '';
            let addAStyle = '';
            let addSelectClass = '';
            if (reservation.date == selectedDate) {
              addTdStyle = 'background-color: #527342;';
              addAStyle = 'background-color: #fff;';
              addSelectClass = 'select-date reservation-check-mark';
            }

            if (LODGE_START_DATE.isAfter(date)) {
              $('#lodge-b-reservation-num').append(`<td class='unavailable-reservation'><span data-date=${reservation.date} data-site='lodge-b'>-</span></td>`);
            } else if (futureDate.getTime() > date.getTime()) {
              if (reservation.non_business_date === true || $(numberOfSections).val() > 2 || lodgeBLimitation()) {
                $('#lodge-b-reservation-num').append(`<td class='unavailable-reservation'><div data-date=${reservation.date} data-site='lodge-b'>-</div></td>`);
              } else {
                if (reservation.reservation_rate >= 100) {
                  $('#lodge-b-reservation-num').append(`<td class='unavailable-reservation times-mark'><span data-date=${reservation.date} data-site='lodge-b'></span></td>`);
                } else if (reservation.reservation_rate >= 80) {
                  $('#lodge-b-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='lodge-b' data-date=${reservation.date} data-site='lodge-b' href='' style='${addAStyle}'>${charge.toLocaleString()}<span class='click-underline triangle-mark'></span></a></td>`);
                } else {
                  $('#lodge-b-reservation-num').append(`<td class='${addSelectClass}' style='${addTdStyle}'><a class='lodge-b' data-date=${reservation.date} data-site='lodge-b' href='' style='${addAStyle}'>${charge.toLocaleString()}<span class='click-underline circle-mark'></span></a></td>`);
                }
              }
            } else {
              $('#lodge-b-reservation-num').append(`<td class='unavailable-reservation'><span data-date=${reservation.date} data-site='lodge-b'></span></td>`);
            }
          })
          $('#lodge-b-reservation-num').prepend(`<th><a href='' class='text-link lodge-b-modal-button' data-target='#campingAreaModal' data-toggle='modal'>${lodgeBReservations[0].site_name}</a></th>`);
        }

        let firstDate;
        let lastDate;

        response.data.forEach(d => {
          if (d.length > 0) {
            firstDate = d[0].date;
            lastDate = d[4].date;
            return;
          }
        })

        firstDateWeakMap.set(firstDateValue, firstDate);
        lastDateWeakMap.set(lastDateValue, lastDate);

        const $element = $('.reservation-check-mark').children('a');
        let dateRange = $(dateRangePicker).val();
        const dateRangeArray = dateRange.split('-');
        const nights = parseInt(dateRangeArray[1]);
        const site = $element.data('site')
        for (let i = 1; i <= nights; i++) {
          let dt = moment(date).add(i, 'd').format('YYYY-MM-DD')
          let ele = $(`[data-date=${dt}]`).filter(`[data-site=${site}]`)
          ele.parent().addClass('reservation-check-mark');
          ele.parent().addClass('select-date')
          ele.parent().addClass('camping-reservation-after-the-second-date')
        }
      }
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }

  const lodgeALimitation = () => {
    const totalNum = calcTotalPeople();
    if (totalNum > 8 && $(numberOfSections).val() == 2) {
      return true;
    }
    if (totalNum > 4 && $(numberOfSections).val() == 1) {
      return true;
    }
    return false;
  }

  const lodgeBLimitation = () => {
    const totalNum = calcTotalPeople();
    if (totalNum > 16 && $(numberOfSections).val() == 2) {
      return true;
    }
    if (totalNum > 8 && $(numberOfSections).val() == 1) {
      return true;
    }
    return false;
  }

  const checkValidPeopleAndSections = () => {
    const totalNum = calcTotalPeople();
    if ($('#camping-area-id').val() == 5) {
      if (totalNum > 8 && $(numberOfSections).val() == 2) {
        $(campingShowDisabledButton).show();
        $(campingShowActiveButton).hide();
        $(campingDisabledButton).prop('disabled', true);
      }
      if (totalNum > 4 && $(numberOfSections).val() == 1) {
        $(campingShowDisabledButton).show();
        $(campingShowActiveButton).hide();
        $(campingDisabledButton).prop('disabled', true);
      }
    }
    if ($('#camping-area-id').val() == 6) {
      if (totalNum > 16 && $(numberOfSections).val() == 2) {
        $(campingShowDisabledButton).show();
        $(campingShowActiveButton).hide();
        $(campingDisabledButton).prop('disabled', true);
      }
      if (totalNum > 8 && $(numberOfSections).val() == 1) {
        $(campingShowDisabledButton).show();
        $(campingShowActiveButton).hide();
        $(campingDisabledButton).prop('disabled', true);
      }
    }
  }

  const calcTotalPeople = () => {
    return parseInt($(adultNumPulldown).val()) + parseInt($(kidsNumPulldown).val()) + parseInt($(babyNumPulldown).val());
  }

  const showCalendarDate = data => {
    let first;
    let date;
    let reservations;
    data.forEach(d => {
      if (d.length > 0) {
        first = moment(d[0].date);
        reservations = d;
        return;
      }
    })
    reservations.forEach(reservation => {
      date = new Date(reservation.date);
      const jaWDay = getJapaneseWDay(date);
      const reservationDate = date.getDate();
      const wDay = date.getDay();
      if (wDay === 0) {
        $('#calendar-camping-date').append(`<td class='camping-calender-date sunday-reservation'>${jaWDay}<br>${reservationDate}</td>`);
      } else if (wDay === 6) {
        $('#calendar-camping-date').append(`<td class='camping-calender-date saturday-reservation'>${jaWDay}<br>${reservationDate}</td>`);
      } else {
        $('#calendar-camping-date').append(`<td class='camping-calender-date'>${jaWDay}<br>${reservationDate}</td>`);
      }
    })

    let month = first.month()
    let pre_count = 0;
    let last_count = 0;
    for (let i=0; i < 5; i++) {
      let new_date = moment(first).add(i, 'd')
      if (new_date.month() == month) {
        pre_count++;
      }
      else {
        last_count++;
      }
    }
    $('#calendar-camping-month').append(`<td colspan="${pre_count}"><p class="calendar-camping-year">${moment(first).year()}年</p>${moment(first).month() + 1}月</td>`);
    if (last_count > 0) {
      $('#calendar-camping-month').append(`<td colspan="${last_count}"><p class="calendar-camping-year">${moment(first).add(5, 'd').year()}年</p>${moment(first).add(5, 'days').month() + 1}月</td>`);
    }
  }

  const showCalendarArea = () => {
    $('#calendar-camping-month').prepend('<th></th>');
    $('#calendar-camping-date').prepend('<th>サイト</th>');
  }

  const hideReservationStatusCalendar = () => {
    $(campingCalendarInfo).hide();
    $(calendarTable).hide();
    $(calendarTableText).hide();
    $(prevWeekButton).hide();
    $(nextWeekButton).hide();
    $(campingShowDisabledButton).show();
    $(campingShowActiveButton).hide();
    $(campingDisabledButton).prop('disabled', true);
    $('.before_info_open_camping_calendar').show();
    $('.after_info_open_camping_calendar').removeClass('active');
  }

  const setSiteAValue = e => {
    e.preventDefault();
    $('body').off('change', dateRangePicker);
    document.getElementById('camping-area-id').value = 4;
    setSiteCommonValue(e);
    $('body').on('change', dateRangePicker, dateRangeChange);
  }

  const setSiteBValue = e => {
    e.preventDefault();
    $('body').off('change', dateRangePicker)
    document.getElementById('camping-area-id').value = 3;
    setSiteCommonValue(e);
    $('body').on('change', dateRangePicker, dateRangeChange);
  }

  const setSiteCNomalValue = e => {
    e.preventDefault();
    $('body').off('change', dateRangePicker)
    document.getElementById('camping-area-id').value = 1;
    setSiteCommonValue(e);
    $('body').on('change', dateRangePicker, dateRangeChange);
  }

  const setLodgeAValue = e => {
    e.preventDefault();
    $('body').off('change', dateRangePicker)
    document.getElementById('camping-area-id').value = 5;
    setSiteCommonValue(e);
    $('body').on('change', dateRangePicker, dateRangeChange);
  }

  const setLodgeBValue = e => {
    e.preventDefault();
    $('body').off('change', dateRangePicker)
    document.getElementById('camping-area-id').value = 6;
    setSiteCommonValue(e);
    $('body').on('change', dateRangePicker, dateRangeChange);
  }

  const setSiteCommonValue = e => {
    $(calendarTable).find('td').css('background-color', '').removeClass('select-date').removeClass('camping-reservation-first-date').removeClass('camping-reservation-after-the-second-date')
    $(calendarTable).find('td').css('background-color', '').removeClass('reservation-check-mark')
    $(calendarTable).find('a').css('background-color', '')

    const $element = $(e.currentTarget);
    $element.parent().addClass('camping-reservation-first-date')
    $element.parent().addClass('reservation-check-mark');
    $element.parent().addClass('select-date')
    var date = $element.data('date');
    $('#camping-reserve-start-date').val(date);
    $(campingShowDisabledButton).hide();
    $(campingShowActiveButton).show();
    $(campingDisabledButton).prop('disabled', false);

    let dateRange = $(dateRangePicker).val();
    const dateRangeArray = dateRange.split('-');
    const nights = parseInt(dateRangeArray[1]);
    const site = $element.data('site')
    for (let i = 1; i <= nights; i++) {
      let dt = moment(date).add(i, 'd').format('YYYY-MM-DD')
      let ele = $(`[data-date=${dt}]`).filter(`[data-site=${site}]`)
      ele.parent().addClass('reservation-check-mark');
      ele.parent().addClass('select-date')
      ele.parent().addClass('camping-reservation-after-the-second-date')
    }

    resetReserveDateToPicker(date);
  }

  const resetReserveDateToPicker = (date) => {
    let dateRange = $(dateRangePicker).val();
    const dateRangeArray = dateRange.split('-');
    const nights = dateRangeArray[1];
    const endDate = moment(date).add(parseInt(nights), 'd')

    setReserveEndDateValue(endDate.format('YYYY-MM-DD'));
    $(dateRangePicker).daterangepicker({
      minDate: MINDATE.format('YYYYMMDD'),
      startDate: date,
      endDate: endDate,
      locale: {
        format: 'YYYY年MM月DD日（dd）',
        applyLabel: '選択する',
        cancelLabel: '閉じる'
      }
    });
  }

  const setReserveEndDateValue = (endDateString) => {
    $('#camping-reserve-end-date').val(moment(endDateString).add(-1, 'days').format('YYYY-MM-DD'))
    $('#camping-checkout-date').val(endDateString)
  }

  const registerDiffReserveDateLength = (reserveEndDateSelectObj, reserveStartDateSelectObj) => {
    var diffTime = reserveEndDateSelectObj.getTime() - reserveStartDateSelectObj.getTime();
    var diffDate = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    diffReserveDateLength.set(totalDiffDateKey, diffDate);
  }

  const removePrependedCalendarInfo = () => {
    $('#calendar-camping-month').empty();
    $('#calendar-camping-date').empty();
    $('#calendar-camping-a-site-reservation-num').empty();
    $('#calendar-camping-b-site-reservation-num').empty();
    $('#calendar-camping-site-c-nomal-reservation-num').empty();
    $('#lodge-a-reservation-num').empty();
    $('#lodge-b-reservation-num').empty();
  }

  const getStringFromDate = lastDate => {
    const year_str = lastDate.getFullYear();
    var month_str = 1 + lastDate.getMonth();
    var day_str = lastDate.getDate();
    month_str = ('0' + month_str).slice(-2);
    day_str = ('0' + day_str).slice(-2);
    let nextDateString = 'YYYY-MM-DD'
    nextDateString = nextDateString.replace(/YYYY/g, year_str);
    nextDateString = nextDateString.replace(/MM/g, month_str);
    nextDateString = nextDateString.replace(/DD/g, day_str);
    return nextDateString;
  }

  const getJapaneseWDay = date => {
    var weekChars = ['日', '月', '火', '水', '木', '金', '土'];
    const wDay = date.getDay();
    return weekChars[wDay];
  }

  const checkSubscriptionTotalNum = (reservation) => {
    let totalNum = parseInt($(adultNumPulldown).val()) + parseInt($(kidsNumPulldown).val());

    if (reservation.camping_subscriber == true) {
      return totalNum;
    }
  }

  const prepareLodgeCharge = (reservation, adultTotalPeople) => {
    const taxRate = $('#data-tax').data('tax-rate');
    const charge = reservation.charge / adultTotalPeople;
    return Math.floor(charge * (1 + taxRate));
  }

  const prepareReservationCharge = (reservation, subscriptionTotalPeople) => {
    const taxRate = $('#data-tax').data('tax-rate');
    let charge;
    if (subscriptionTotalPeople != null) {
      charge = reservation.charge - 100;
    } else {
      charge = reservation.charge;
    }
    return charge * (1 + taxRate);
  }

  const limitNumberOfSections = () => {
    const totalNum = calcTotalPeople();
    if (totalNum <= 4) {
      $(numberOfSections).children('[value=2]').remove();
    } else {
      if ($(numberOfSections).children('[value=2]').length < 1) {
        $(numberOfSections).append($('<option>').val(2).text('2'));
      }
    }
    if (totalNum <= 8) {
      $(numberOfSections).children('[value=3]').remove();
    } else {
      if ($(numberOfSections).children('[value=3]').length < 1) {
        $(numberOfSections).append($('<option>').val(3).text('3'));
      }
    }
    if (totalNum <= 12) {
      $(numberOfSections).children('[value=4]').remove();
    } else {
      if ($(numberOfSections).children('[value=4]').length < 1) {
        $(numberOfSections).append($('<option>').val(4).text('4'));
      }
    }
    if (totalNum <= 16) {
      $(numberOfSections).children('[value=5]').remove();
    } else {
      if ($(numberOfSections).children('[value=5]').length < 1) {
        $(numberOfSections).append($('<option>').val(5).text('5'));
      }
    }
  }
  $(init);
})();
